import {
  // reason: this is the wrapped component which we will allow since this is the exported version
  // eslint-disable-next-line @dhl/dhl-ui/no-restricted-imports
  Switch as MuiSwitch,
  type SwitchProps as MuiSwitchProps,
  FormControlLabel,
} from '@mui/material'
import { FormHelperText } from '../FormHelperText'
import { type DataTestIdAttribute } from '../../types'

export type SwitchProps = Pick<
  MuiSwitchProps,
  | 'autoFocus'
  | 'checked'
  | 'defaultChecked'
  | 'disabled'
  | 'edge'
  | 'id'
  | 'name'
  | 'onChange'
  | 'readOnly'
  | 'required'
  | 'slotProps'
  | 'tabIndex'
  | 'type'
  | 'value'
> & {
  /**
   * We need a label for accessibility but you can have your own setup for using
   * an accessible switch. In most use cases you will need to have this label.
   */
  label?: string
  /**
   * helper text to show additional information under the Switch
   * @default false
   */
  helperText?: React.ReactNode
  /**
   * flag to indicate whether an error occurred, applied to the helperText
   * @default false
   */
  error?: boolean
} & DataTestIdAttribute

/**
 * Switch
 *
 * Demos:
 * - [Switch](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/docs/inputs-switch--docs)
 *
 */

export const Switch = ({ label, helperText, error, ...props }: SwitchProps) => (
  <>
    <FormControlLabel
      sx={!label ? { mr: 0, width: 'fit-content' } : {}}
      control={<MuiSwitch {...props} />}
      label={label}
    />
    {helperText && (
      <FormHelperText sx={{ mt: -1 }} error={error}>
        {helperText}
      </FormHelperText>
    )}
  </>
)
